<template>
  <div>
    CREATE RECORD
    <hr>
    <b-form-group :class="{'error-input' : $v.data_record.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_record.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_record.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_record.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Select Form'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeRecord">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveRecord">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_record: {
      form: {
        required,
      },
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_record: {
        form: null,
        title: '',
      },
    };
  },
  computed: {
    generateDataRecord() {
      const infoName = this.data_record.form.name;
      const data = {
        info: JSON.stringify({
          id: this.data_record.form.id,
          name: infoName.toLowerCase().replace(/\s/g, '-'),
          title: this.data_record.title,
        }),
        value_id: this.data_record.form.id,
        name: this.data_record.form.name,
        widget_master_id: this.dataMaster.id,
        type: 1,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataRecordUpdate() {
      const infoName = this.data_record.form.name;
      const data = {
        info: JSON.stringify({
          id: this.data_record.form.id,
          name: infoName.toLowerCase().replace(/\s/g, '-'),
          title: this.data_record.title,
        }),
        value_id: this.data_record.form.id,
        name: this.data_record.form.name,
        widget_master_id: this.dataMaster.id,
        type: 1,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_record.form = {
        id: JSON.parse(this.dataEdit.info).id,
        name: JSON.parse(this.dataEdit.info).name,
        label: JSON.parse(this.dataEdit.info).name,
      };
      this.data_record.title = JSON.parse(this.dataEdit.info).title;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveRecord() {
      this.$v.data_record.$touch();
      if (!this.$v.data_record.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataRecord;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataRecordUpdate;
          this.updateWidget({ widgetId, dataParam });
        }

        this.closeRecord();
      }
    },

    closeRecord() {
      this.$emit('close-field');
      this.data_record.form = null;
      setTimeout(() => {
        this.$v.data_record.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jCreateRecordSetup.vue